import {StockItem} from '../../../shared-utilities/models-old/datastructures';
import {IPaginationData} from '../../../shared/shared-models/pagination/pagination-data';
import {ISearchableFields} from '../../../shared/shared-models/type-sense/default-searchable-fields';
import {IFacetCounts} from '../../../shared/shared-models/type-sense/type-sense-types';
import {TLineColour} from '../../settings-new/models';

export const AUTO_ORDER_MAX_MANUAL_ADD_ITEMS = 100;

//#region INTERFACE IAutoOrderAddStockItems

/**
 * ### IAutoOrderAddStockItems
 * Represents the data structure for adding stock items with pagination, filtering, and facet counts.
 *
 * @interface IAutoOrderAddStockItems
 * @extends Object
 * @description This interface encapsulates the payload required when adding stock items,
 *              including pagination details, the list of stock items, optional facet counts,
 *              optional filtering criteria, and optional line color customization.
 *
 * @example
 * const addStockItemsPayload: IAutoOrderAddStockItems = {
 *   paginationData: { page: 1, pageSize: 20 },
 *   stockItems: [{ id: '123', name: 'Item A', ... }],
 *   facetCounts: { category: 5, brand: 3 },
 *   filter: { name: { searchTerm: 'apple' } },
 *   lineColour: 'blue'
 * };
 */
export interface IAutoOrderAddStockItems extends Object {
  /**
   * Pagination information to control page size and current page.
   *
   * @type {IPaginationData}
   * @example { page: 1, pageSize: 20 }
   */
  paginationData: IPaginationData;

  /**
   * Array of stock items to be added.
   *
   * @type {StockItem[]}
   * @example [{ id: '123', name: 'Item A' }]
   */
  stockItems: StockItem[];

  /**
   * Optional facet counts representing counts of filtered facets.
   *
   * @type {IFacetCounts}
   * @optional
   * @example { category: 5, brand: 3 }
   */
  facetCounts?: IFacetCounts;

  /**
   * Optional filter criteria mapped by field keys to searchable fields.
   *
   * @type {{ [key: string]: ISearchableFields }}
   * @optional
   * @example { name: { searchTerm: 'apple' } }
   */
  filter?: Record<string, ISearchableFields>;

  /**
   * Optional line color applied to the items or UI elements.
   *
   * @type {TLineColour}
   * @optional
   * @example 'blue'
   */
  lineColour?: TLineColour;
}

//#endregion
